import React, { FC } from 'react'
import { useScroll } from 'Pages/landings/common/hooks/useScroll'
import { Button } from 'Pages/landings/common/components/Button'
import './style.scss'

const dataList = [
	{
		png: 'credit_1',
		title: 'Кредит Оборотный',
		subTitle:
			'Пополнение оборотных средств · ' +
			'Осуществление текущих расходов · ' +
			'Исполнение текущих, государственных и экспортных контрактов · ' +
			'Финансирование любых целей без подтверждения целевого использования · ' +
			'Рефинансирование оборотных кредитов других банков',
		time: 'до 36 месяцев',
		rate: 'процентная ставка',
		sum: 'от 100 000 ₽',
	},
	{
		png: 'credit_2',
		title: 'Кредит Инвестиционный',
		subTitle:
			'Инвестирование в недвижимость, строительство и другое имущество · ' +
			'Рефинансирование задолженности перед банками и лизинговыми компаниями · ' +
			'Приобретение жилой или коммерческой недвижимости под залог приобретаемых объектов · ' +
			'Покупка транспорта и оборудования для хозяйственной деятельности',
		time: 'до 300 месяцев',
		rate: 'процентная ставка',
		sum: 'от 100 000 ₽',
	},
	{
		png: 'credit_3',
		title: 'Овердрафт',
		subTitle: 'Оплата срочных платежей при недостатке средств на счёте',
		time: 'до 36 месяцев',
		rate: 'процентная ставка',
		sum: 'до 34 млн ₽',
	},
	{
		png: 'credit_4',
		title: 'Кредит на Проект',
		subTitle:
			'Развитие бизнеса Начало деятельности в новой сфере ' +
			'Модернизация производства ' +
			'Любые бизнес-цели под залог доходной недвижимости',
		time: 'до 120 месяцев',
		rate: 'процентная ставка',
		sum: 'от 2,5 млн ₽',
	},
]

export const CreditListComponent: FC = () => {
	const { scrollIntoBlock } = useScroll()

	const className = {
		buttonBlack: 'landing-credits_button-black',
		creditList: 'landing-credits_credit-list',
		creditListItem: 'landing-credits_credit-list_item',
		creditListInline: 'landing-credits_credit-list_inline',
		icon: 'landing-credits_credit-list_icon',
		title: 'landing-credits_credit-list_title',
		subTitle: 'landing-credits_credit-list_sub-title',
		timeRateSum: 'landing-credits_credit-list_time-rate-sum',
		button: 'landing-credits_credit-list_button',
		width_100: 'landing-credits_width_100',
	}

	const renderItem = (item: typeof dataList[0]) => {
		const { png, title, subTitle, time, rate, sum } = item
		return (
			<div className={className.creditListItem} key={png}>
				<div>
					<div className={className.icon}>
						<img src={`../img/${png}.png`} alt="" />
					</div>
				</div>
				<div className={className.width_100}>
					<div className={className.title}>{title}</div>
					<div className={className.subTitle}>{subTitle}</div>
					<div className={className.creditListInline}>
						<div>
							<div className={className.timeRateSum}>{time}</div>
							<div className={className.subTitle}>срок кредита</div>
						</div>
						<div>
							<div className={className.timeRateSum}>{rate}</div>
							<div className={className.subTitle}>определяется индивидуально</div>
						</div>
						<div>
							<div className={className.timeRateSum}>{sum}</div>
							<div className={className.subTitle}>
								{title === 'Овердрафт' ? 'максимальная' : 'минимальная'} сумма
							</div>
						</div>
					</div>
					<div className={className.button}>
						<Button wide onClick={() => scrollIntoBlock('#blockForm')}>
							Подать заявку онлайн
						</Button>
					</div>
				</div>
			</div>
		)
	}

	return (
		<div id="blockCredits" className={className.creditList}>
			{dataList.map((item) => renderItem(item))}
		</div>
	)
}
